// Import React and SeeMoreButton styles
import React from "react";
import "../../../css/buttons/SeeMoreButton.css";

// SeeMoreButton component renders a stylized button for "See More" actions
// children: Button label (defaults to "SEE MORE")
// onClick: Function to call when button is clicked
const SeeMoreButton = ({ children = "SEE MORE", onClick }) => (
  <button className="see-more-btn" onClick={onClick}>
    {/* Decorative line element for visual style */}
    <span className="see-more-line" />
    {/* Button text, customizable via children prop */}
    <span className="nav gray">{children}</span>
  </button>
);

// Export the SeeMoreButton component for use in other parts of the app
export default SeeMoreButton;
